import React from 'react';
import styled from "styled-components";

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

function Loader() {

    return (
        <LoaderContainer>
            <img src="/images/loading.svg" alt="loading" style={{width: "20%"}}/>
        </LoaderContainer>
    );
}
export default Loader;



